import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'what_health_and_safety_measures_does_the_fac_have_to_prevent_th'

export const dataPointDefinition = {
  retracedId: 'what_health_and_safety_measures_does_the_fac_have_to_prevent_th',
  name: 'What health and safety measures does the facility have to prevent the spread of contagious diseases?',
  description:
    'Contagious diseases are diseases that can easily spread throughout the worker population, e.g. through physical contact, objects touched by an infected worker, or airborne route. ',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'HANDWASHING_SANITIZING_STATIONS',
      text: 'Handwashing/sanitizing stations',
      externalIds: [
        {
          id: 'hs-fir-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKSTATIONS_ARE_MORE_THAN_6FT_APART',
      text: 'Workstations are more than 6ft apart',
      externalIds: [
        {
          id: 'hs-fir-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PHYSICAL_BARRIERS_BETWEEN_WORKSTATIONS',
      text: 'Physical barriers between workstations',
      externalIds: [
        {
          id: 'hs-fir-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TEMPERATURE_CHECKS_OR_OTHER_HEALTH_SCANS_AS_WORKERS_ENTER_THE_W',
      text: 'Temperature checks or other health scans as workers enter the workplace',
      externalIds: [
        {
          id: 'hs-fir-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TRAINING_FOR_WORKERS_ON_PREVENTING_THE_SPREAD_OF_CONTAGIOUS_DIS',
      text: 'Training for workers on preventing the spread of contagious diseases',
      externalIds: [
        {
          id: 'hs-fir-11x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PROVIDING_WORKERS_WITH_ADDITIONAL_PPE_E_G_MASKS_GLOVES_SPECIFIC',
      text: 'Providing workers with additional PPE (e.g. masks, gloves) specifically to prevent the spread of contagious diseases',
      externalIds: [
        {
          id: 'hs-fir-12x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'hs-fir-13x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'hs-fir-14f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NOT_APPLICABLE',
      text: 'Not Applicable',
      externalIds: [
        {
          id: 'hs-fir-15x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-fir-16x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'HANDWASHING_SANITIZING_STATIONS',
                'WORKSTATIONS_ARE_MORE_THAN_6FT_APART',
                'PHYSICAL_BARRIERS_BETWEEN_WORKSTATIONS',
                'TEMPERATURE_CHECKS_OR_OTHER_HEALTH_SCANS_AS_WORKERS_ENTER_THE_W',
                'TRAINING_FOR_WORKERS_ON_PREVENTING_THE_SPREAD_OF_CONTAGIOUS_DIS',
                'PROVIDING_WORKERS_WITH_ADDITIONAL_PPE_E_G_MASKS_GLOVES_SPECIFIC',
                'OTHER',
                'NOT_APPLICABLE',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-fir-6',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16910,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
